import { Injectable } from '@angular/core';
import { format, getDate } from 'date-fns';

import { IQuotes, PaymentScheduleItem, QuoteSummaryModel } from '@amfam/shared/models';
import { CopyService } from '@amfam/shared/utility/shared-services';

@Injectable({ providedIn: 'root' })
export class VehicleQuoteService {
  constructor(private copyService: CopyService) {}

  mapQuotes(
    currentMonthlyCost: number,
    currentTotalCost: number,
    newMonthlyCost: number,
    newTotalCost: number,
    termMonths: string,
    context = 'ADD'
  ): IQuotes {
    const dollarUS = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    const validParams = [
      currentMonthlyCost,
      currentTotalCost,
      newMonthlyCost,
      newTotalCost,
      termMonths
    ].every(arg => !!arg);
    if (!validParams) return null;

    const feature = context === 'ADD' ? 'addVehicle' : 'replaceVehicle';

    const difference = newMonthlyCost - currentMonthlyCost;
    const subTextRef =
      difference >= 0
        ? `policy.premiumBilling.${feature}.quoteIncreasedSubText`
        : `policy.premiumBilling.${feature}.quoteDecreasedSubText`;
    const newQuote = {
      premiumPerMonth: {
        amount: dollarUS.format(+newMonthlyCost.toFixed(2)),
        term: 'month'
      },
      premiumOther: {
        amount: dollarUS.format(+newTotalCost.toFixed(2)),
        term: (termMonths || '').toString().replace(/\D/g, '') + ' months'
      },
      subText: this.copyService.getCopy(subTextRef, {
        difference: dollarUS.format(+(difference >= 0 ? difference : -1 * difference).toFixed(2)),
        currentPremium: dollarUS.format(+currentMonthlyCost.toFixed(2)),
        newPremium: dollarUS.format(+newMonthlyCost.toFixed(2))
      })
    };

    const currentQuote = {
      header: this.copyService.getCopy('policy.premiumBilling.quoteHeader'),
      premiumPerMonth: {
        amount: dollarUS.format(+currentMonthlyCost.toFixed(2)),
        term: 'month'
      },
      premiumOther: {
        amount: dollarUS.format(+currentTotalCost.toFixed(2)),
        term: (termMonths || '').toString().replace(/\D/g, '') + ' months'
      },
      subText: ''
    };
    return {
      new: newQuote,
      current: currentQuote
    };
  }

  mapPayments(payments: PaymentScheduleItem[]): QuoteSummaryModel[] {
    const dollarUS = Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD'
    });
    return payments.map(payment => ({
      option: `${format(payment.dueDate, 'MMMM')}  ${getDate(payment.dueDate)}`,
      value: dollarUS.format(payment.estPaymentAmount)
    }));
  }
}
